import React from "react";
import { useDispatch } from "react-redux";
import { setCamera } from "redux/actions/cameraActions";
import { CameraOverlayContainer, CloseButton } from "./CameraOverlayStyled";
import { event } from "analytics";

export const CameraOverlay = () => {
  const dispatch = useDispatch();
  const onclick = () => {
    dispatch(setCamera(false));
    event("close", "camera");
  };
  return (
    <CameraOverlayContainer>
      <CloseButton data-testid="close_camera-button" onClick={onclick} />
    </CameraOverlayContainer>
  );
};
